<div class="login-container">
  <div class="login-content">
    <div class="login-header">
      <h1>{{ titleText }}</h1>
      <p class="subtitle">{{ subtitleText }}</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="username">{{ usernameLabel }} <span class="required">{{ requiredText }}</span></label>
        <input 
          type="text" 
          id="username" 
          formControlName="username"
          [class.error]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched"
          [placeholder]="usernamePlaceholder"
          autocomplete="username"
        />
        <span class="error-text" *ngIf="getFieldError('username')">
          {{ getFieldError('username') }}
        </span>
      </div>

      <div class="form-group">
        <label for="password">{{ passwordLabel }} <span class="required">{{ requiredText }}</span></label>
        <input 
          type="password" 
          id="password" 
          formControlName="password"
          [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          [placeholder]="passwordPlaceholder"
          autocomplete="current-password"
        />
        <span class="error-text" *ngIf="getFieldError('password')">
          {{ getFieldError('password') }}
        </span>
      </div>

      <div class="form-actions">
        <button 
          type="submit" 
          class="submit-button"
          [disabled]="loading || loginForm.invalid"
        >
          <span *ngIf="!loading">{{ submitText }}</span>
          <span *ngIf="loading">{{ submittingText }}</span>
        </button>
      </div>

      <div class="register-link-container">
        <p>{{ noAccountText }} <a href="/registration/cargo-owner" class="register-link" (click)="openRolePicker($event)">{{ registerText }}</a></p>
      </div>
    </form>
  </div>
</div>

<!-- Перед регистрацией — выбор роли -->
<app-role-picker *ngIf="rolePickerOpen" (closed)="rolePickerOpen = false"></app-role-picker>
